
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ValidationObserver } from 'vee-validate';
import moment from 'moment';
import { WEEKDAYS } from '@/util/constant';

interface OpeningHour {
  weekday: number;
  openedAt: string | null;
  closedAt: string | null;
  openedAtMenu: false;
  closedAtMenu: false;
}

@Component
export default class VOpeningHour extends Vue {
  @Prop({ type: String, default: '' }) public title!: string;

  public $refs!: {
    observer: InstanceType<typeof ValidationObserver>;
  };
  public hours: OpeningHour[] = [];

  get weekdays() {
    const days = WEEKDAYS(this.$i18n);

    return days.map((day, index) => {
      return { value: index, text: day };
    });
  }

  public addOpeningHour() {
    this.hours.push({
      weekday: 0,
      openedAt: null,
      openedAtMenu: false,
      closedAt: null,
      closedAtMenu: false,
    });
  }

  public getHours() {
    return this.hours.map((h: OpeningHour) => {
      return {
        ...h,
        openedAt: this.getUtcTime(h.openedAt!),
        closedAt: this.getUtcTime(h.closedAt!),
      };
    });
  }

  public setHours(hours: OpeningHour[], overwrite: boolean = false): void {
    if (overwrite) {
      this.hours = [];
    }
    for (const hour of hours) {
      this.hours.push({
        weekday: hour.weekday,
        openedAtMenu: false,
        closedAtMenu: false,
        // @ts-ignore
        openedAt: this.toLocaleTime(hour.openedAt),
        // @ts-ignore
        closedAt: this.toLocaleTime(hour.closedAt),
      });
    }
  }

  public getUtcTime(time: string): string | null {
    if (!moment(time, 'HH:mm').isValid()) {
      return null;
    }

    return moment(time, 'HH:mm').subtract(120, 'minutes').format('HH:mm');
  }

  public toLocaleTime(time: string): string | null {
    if (!moment(time, 'HH:mm').isValid()) {
      return null;
    }

    return moment(time, 'HH:mm').add(120, 'minutes').format('HH:mm');
  }

  public removeHour(item: OpeningHour) {
    this.hours.splice(this.hours.indexOf(item), 1);
  }

  public validate(): Promise<boolean> {
    return this.$refs.observer.validate();
  }
}
